import {History} from '../../../graphql-typings/graphql';
import {ChartFunction, FunctionName} from './chart-function-types';

export abstract class AbstractFunction implements ChartFunction {

  readonly name: FunctionName;
  readonly longNameKey: string;

  protected constructor(name: FunctionName, longNameKey: string) {
    this.name = name;
    this.longNameKey = longNameKey;
  }

  abstract run(history: History[], padValues?: boolean): History[];
}
